import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MultipleSelectQuestion } from '@app/courses/models/quiz/multiple-select-question';
import { ChoiceOption } from '@app/courses/models/quiz/choice-option';
import { OnlineStatusService } from '@app/common/online-status/online-status.service';
import { OnlineStatusType } from '@app/common/online-status/online-status-type.enum';
import { Subscription } from 'rxjs';
import { StaticText } from '@app/common/static-text';

@Component({
    selector: 'ebs-multiple-answers-question',
    templateUrl: './multiple-answers-question.component.html',
    styleUrls: ['./multiple-answers-question.component.scss'],
    standalone: false
})
export class MultipleAnswersQuestionComponent implements OnInit, OnDestroy {
  @Input() question: MultipleSelectQuestion;
  @Input() showFeedback: boolean;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  theSubscription: Subscription;
  isOffline: boolean;
  offlineMessage = StaticText.quizOfflineMessage;

  constructor(private onlineStatusService: OnlineStatusService) {
    this.onlineStatusService.isOffline().subscribe(x => {
        this.isOffline = x;
    }, error=>{
        this.isOffline = false;
    });
    this.theSubscription = this.onlineStatusService.status.subscribe(
      event => {
        this.isOffline = (event === OnlineStatusType.OFFLINE) ? true : false
      }
    )
  }

  ngOnInit() {
    if (this.question.options != null) {
      for (var i = 0; i < this.question.options.length; i++) {
        this.question.options[i].isSelected = false;
      }
      this.question.options = this.shuffle(this.question.options);
    }

  }

  shuffle(array: Array<ChoiceOption>) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  answerIsCorrect() {
    let newQuestion = new MultipleSelectQuestion('', '', null);
    newQuestion = Object.assign(newQuestion, this.question);
    return newQuestion.getMark() > 0;
  }

  checkboxChanged() {
    this.question.isComplete = true;
    this.notify.emit(true);
  }

  ngOnDestroy(): void {
    this.theSubscription.unsubscribe();
  }

}